import { render, staticRenderFns } from "./MobileCurrentInfo.vue?vue&type=template&id=378105b6&"
import script from "./MobileCurrentInfo.vue?vue&type=script&lang=js&"
export * from "./MobileCurrentInfo.vue?vue&type=script&lang=js&"
import style0 from "./MobileCurrentInfo.vue?vue&type=style&index=0&id=378105b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports